import script from "./BanishMob.vue?vue&type=script&setup=true&lang=js"
export * from "./BanishMob.vue?vue&type=script&setup=true&lang=js"

import "./BanishMob.vue?vue&type=style&index=0&id=001b96fc&lang=css"

const __exports__ = script;

export default __exports__